module.exports = __webpack_public_path__ + "img/product_en.b50cb473.png";